<template>
    <LoadingCard v-if="loading" />
    <div class="content__inner content__inner--md" v-else>
        <header class="content__title pl-0">
            <h1>Growers</h1>
        </header>

        <div class="toolbar">
            <div class="toolbar__search d-block">
                <input type="text" placeholder="Search..." v-model="searchTerm">
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6" v-for="user in filteredUsers">
                <div class="card p-3">
                    <div class="row align-items-center">
                        <div class="col-2">
                            <Avatar class="user__img" :src="user.avatar" :size="39" backgroundColor="#61c365" :username="user.name" />
                        </div>
                        <div class="col-7">
                            <h5 class="mb-1">{{ user.business_name }}</h5>
                            <p>
                                <router-link :to="{name: 'growers.chemicals.browse', params: {growerId: user.id}}">Chemicals</router-link>
                                |
                                <router-link :to="{name: 'growers.diary.create', params: {growerId: user.id}}">Bulk Spray</router-link>
                                |
                                <router-link :to="{name: 'growers.orchard-maps.browse', params: {growerId: user.id}}">Orchard Maps</router-link>
                            </p>
                        </div>
                        <div class="col-3 text-right">
                            <router-link :to="{name: 'growers.blocks.browse', params: {growerId: user.id}}" class="btn btn--icon btn-light">
                                <i class="zmdi zmdi-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import listUsersQuery from '@views/Growers/ContractorBrowse/queryListGrowers.graphql';
import Avatar from 'vue-avatar/src/Avatar';

export default {
  name: 'BrowseGrowers',
  apollo: {
    users: {
      query: listUsersQuery,
      update: data => data.filterContractorGrowerLinkGrowers,
    },
  },
  components: {
    Avatar,
  },
  computed: {
    filteredUsers() {
      if (this.searchTerm.length === 0) {
        return this.users;
      }
      return this.users.filter(user => user.business_name.includes(this.searchTerm));
    },
  },
  mounted() {
  },
  data() {
    return {
      users: [],
      searchTerm: '',
      loading: 0,
    };
  },
  methods: {},
};
</script>
